import { styled } from '@mui/system';
import { Box, Typography, ToggleButtonGroup } from '@mui/material';

// Styled MUI components
export const StyledBoxContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.secondary,
  color: theme.colors.white,
  padding: theme.spacing(2),
  paddingTop: theme.spacing(6),
  borderRadius: theme.spacing(1),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

export const StyledSummaryBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-around',
  width: '100%',
}));

export const MetricItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}));

export const MetricLabel = styled(Typography)(({ theme }) => ({
  color: theme.colors.gray,
}));

export const StyledReportPeriod = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  color: theme.colors.gray,
}));

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const StyledBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  minHeight: '500px',
  height: '100%',
  justifyContent: 'center',
  alignItems: 'center',
}));
